export default __webpack_public_path__ + "static/media/Find Treatment_Int 224x224.1e8814f7.jpg";